import {useContext, useMemo} from 'react'
import _ from 'lodash'
import {AuthContext} from '@/features/auth'
import {useNavState} from '@/features/nav-state'
import {DataSourcesContext} from '@/features/data-sources'
import {SemanticFilteringComponent, SemanticFilteringItemType} from '../semantic-filtering'
import {
  epsilon,
  stepSize,
  IFieldDescriptor,
  IMixerConfig,
  IMixerState,
  IMixerUrlParams,
} from '../..'

export interface IChannelsProps {
  isCompact: boolean
  channels: IMixerState['channels']
  config: Partial<IMixerConfig>
  itemFilter?: (item: SemanticFilteringItemType) => boolean
  setItems: React.Dispatch<React.SetStateAction<SemanticFilteringItemType[]>>
  patchConfig: (change: Partial<IMixerConfig>) => void
}

export function Channels(props: IChannelsProps) {
  const {channels, config, itemFilter, setItems} = props

  const {patchNavState} = useNavState<IMixerState, IMixerUrlParams>()

  const {havePermission} = useContext(AuthContext)

  const {mergedItemsStats} = useContext(DataSourcesContext)

  const extraFields: IFieldDescriptor[] = useMemo(
    () =>
      _.compact<IFieldDescriptor>([
        _.has(mergedItemsStats.fields, 'ainar_score') ?
          {
            kind: 'ainar',
            label: 'ainar - rating',
            sourcePath: 'ainar_score',
            range: {min: 0, max: 10},
          }
        : undefined,
        havePermission('api_key.semantic_api') ?
          {
            kind: 'ainar',
            label: 'ainar - ask',
            sourcePath: '',
            initView: 'ask',
            range: {
              min: 0,
              max: 1,
            },
          }
        : undefined,
        {
          kind: 'ainar',
          label: 'ainar - similarity',
          sourcePath: '',
          initView: 'similarity',
          range: {
            min: 0,
            max: 1,
          },
        },
        config.showAdvancedControls ?
          {
            kind: 'expression',
            label: 'expression',
            sourcePath: '',
            initView: 'expression',
            range: {
              min: 0,
              max: 1,
            },
          }
        : undefined,
      ]),
    [mergedItemsStats, config.showAdvancedControls]
  )

  return (
    <div className='channels'>
      <SemanticFilteringComponent
        config={config}
        extraFields={extraFields}
        channels={channels}
        sortEpsilon={epsilon}
        channelProps={{
          stepSize,
        }}
        // actions={isCompact ? undefined : <>
        //     <SettingsPopup
        //         position='bottom right'
        //         content={<>
        //             <Checkbox
        //                 label='advanced mode'
        //                 checked={config.showAdvancedControls}
        //                 onChange={(_e, {checked}) => patchConfig({showAdvancedControls: checked || false})}
        //             />
        //         </>}
        //     />
        // </>}
        itemFilter={itemFilter}
        onChannelsChanged={(data) => patchNavState({channels: data})}
        onResultChanged={setItems}
      />
    </div>
  )
}
